<script type="text/ecmascript-6">
    import Question from "./mixin/Question.vue";

    export default {
        mixins: [
            Question,
        ],
        props: {
            title: {
                default(){
                    return 'Sidepanel Threshold';
                }
            },
            component_id: {
                default(){
                    return 'sidepanel_threshold';
                }
            },
            frameProfile: {
                required: true
            },
            threshold: {
                required: true,
            },
            doorRange: {
                required: true,
            }
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.frameProfile, this.threshold);
            },
            url(){
                return '/api/options/' + this.fabricator + '/sidepanel-threshold?profile=' + this.frameProfile + '&threshold=' + this.threshold + '&door_range=' + this.doorRange;
            },
            cache_key(){
                return '_' + this.frameProfile + '_' + this.threshold + '_' + this.doorRange;
            },
            panel_required(){
                return this.filtered_option_list.length > 1;
            }
        },
        watch: {
            'frameProfile': function (val, oldVal) {
                this.update_options();
            },
            'threshold': function (val, oldVal) {
                this.update_options();
            },
            'doorRange': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
